import angular from "angular";
import AdminEventsEditController from "./admin-edit-event.controller";
import template from "./admin-edit-event.html";
import {
  toHoursAndMinutes,
  timeStringToDate,
} from "../../../common/helpers/time";
function getEvent(EventsModel, $stateParams) {
  return EventsModel.show($stateParams.eventId).then(function (response) {
    const durationParts = toHoursAndMinutes(response.event.duration).split(":");
    response.event.date = new Date(response.event.date);
    response.event.time = timeStringToDate(response.event.time);
    response.event.duration = {};
    response.event.duration.hours = durationParts[0];
    response.event.duration.minutes = durationParts[1];

    return response.event;
  });
}
getEvent.$inject = ["EventsModel", "$stateParams"];

function getCampuses(LocationsModel) {
  return LocationsModel.getLocations().then((response) => {
    return response;
  });
}
getCampuses.$inject = ["LocationsModel"];

function config($stateProvider, $urlRouterProvider, USER_ROLES) {
  $stateProvider.state("drivecoach.admin.events.edit", {
    url: "/edit/:eventId",
    template: template,
    controller: AdminEventsEditController,
    controllerAs: "vm",
    resolve: {
      event: getEvent,
      campuses: getCampuses,
    },
    data: {
      authorizedRoles: [
        USER_ROLES.admin,
        USER_ROLES.administrator,
        USER_ROLES.owner,
        USER_ROLES.staff,
      ],
    },
  });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];

export default angular
  .module("admin.events.edit", [])
  .config(config)
  .controller("AdminEventsEditController", AdminEventsEditController);

